import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';
import { OrderableItemInterface } from '../../types';

@Component({
  selector: 'ui-ordered-list',
  imports: [],
  templateUrl: './ordered-list.component.html',
  styleUrl: './ordered-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderedListComponent<T extends OrderableItemInterface> {
  items = input<T[]>([]);
  savedOrder = input<string[]>([]);
  trackByFn = input<(item: T) => string>((item) => item.id);

  orderChanged = output<string[]>();

  orderedItems = computed(() => {
    const currentItems = this.items();
    const order = this.savedOrder();

    if (!currentItems?.length) return [];

    if (order?.length > 0) {
      return this.sortItemsByOrder(currentItems, order);
    }

    return currentItems;
  });

  private sortItemsByOrder(items: T[], order: string[]): T[] {
    const trackByFn = this.trackByFn();
    const itemsMap = new Map(items.map((item) => [trackByFn(item), item]));

    const orderedItems: T[] = [];
    const usedIds = new Set<string>();

    for (const id of order) {
      const item = itemsMap.get(id);
      if (item) {
        orderedItems.push(item);
        usedIds.add(id);
        itemsMap.delete(id);
      }
    }

    for (const item of itemsMap.values()) {
      orderedItems.push(item);
    }

    return orderedItems;
  }
}
